export default {
  getCountries: state => state.countries,
  getCities: state => state.cities.map(({ id, name }) => ({ id, name })),
  getCounties: state => state.counties.map(({ id, name }) => ({ id, name })),
  getDistricts: state => state.districts.map(({ id, name }) => ({ id, name })),
  getZipCodeAsDistrict: state => districtId => {
    const district =
      state.districts.find(({ id }) => id === districtId) || null;
    return district ? district.zipCode : null;
  },
};
